import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    clientname: {
      validations: []
    },
    partyname: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of people' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    postal: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Event Details',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Nature of this Event (e.g. Birthday Party or Business Dinner)',
            mapping: 'partyname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of People (Minimum of 20) *',
            mapping: 'plannedguestcount'
          }
        ]
      },

      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'starttime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'endtime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Address',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Is there any additional information you would like to add?',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Wyndham Garden Schaumburg Contact Form',
    formId: '744',
    clientKey: '9F8ABBF3-2CB6-40E4-A119-8C18B9C43757',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/wyndhamgarden/form_structure.js